export default "__VITE_ASSET__99d02246__"